
    import {Component, Vue} from 'vue-property-decorator';

    @Component({})
    export default class BrowserWindow extends Vue {
        previousSlide() {
            this.$el.previousElementSibling!.scrollIntoView();
        }
        nextSlide() {
            this.$el.nextElementSibling!.scrollIntoView();
        }
    }
